<label *ngIf="label" for="user">
  <div>{{ label }}<sup *ngIf="required" class="red">*</sup></div>
</label>

<ng-select [ngModel]="multiple ? selectedUsers : selectedUser"
           (ngModelChange)="onSelectionChange($event)"
           [items]="userList"
           (change)="onChange($event)"
           [loading]="loading"
           [multiple]="multiple"
           [placeholder]="placeholder"
           [searchFn]="searchFn"
           [disabled]="disabled"
           [required]="required"
           [clearable]="clearable"
           name="user" id="user">
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span aria-hidden="true" class="ng-value-icon left" (click)="clear(item)">&times;</span>
    <span class="ng-value-label">{{ item.user ? item.user.fullName : item.firstName + ' ' + item.lastName }}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
    <div class="d-flex">
      <div class="mr-1">{{ item.firstName + ' ' + item.lastName }}</div>
      <div class="d-flex">
        <div *ngFor="let domain of domainMap.get(item.id)" class="user-domain-icon-container">
          <img class="user-domain-icon" src="assets/images/sonar-domain-icons/{{getDomainIcon(domain)}}" alt="{{domain}} Icon" />
        </div>
      </div>
    </div>
  </ng-template>
</ng-select>
